import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { useState } from "react";
import { SingleSelect } from "~/components/Select/SingleSelect";
import { WORKSPACE_SELECT_MODAL } from "~/constants/testIDs";
export const WorkspaceSelectModal = (param)=>{
    let { onClose, workspaces, isWorkspacesLoading, description, onSave } = param;
    const [selectedWorkspace, setSelectedWorkspace] = useState(workspaces[0]);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "workspace-select-modal",
        isOpen: true,
        "data-testid": WORKSPACE_SELECT_MODAL,
        onDismiss: onClose,
        description: description,
        ctaPrimaryText: "Save",
        onConfirm: ()=>{
            if (selectedWorkspace) {
                onSave(selectedWorkspace);
            }
        },
        isDisabled: !selectedWorkspace,
        title: "Select workspace",
        children: /*#__PURE__*/ _jsx("div", {
            className: "mt-4",
            children: /*#__PURE__*/ _jsx(SingleSelect, {
                size: "extra-large",
                options: workspaces.map((param)=>{
                    let { name, id } = param;
                    return {
                        label: name,
                        value: id
                    };
                }),
                onSelectionChange: (param)=>{
                    let { chips } = param;
                    const selected = chips[0];
                    setSelectedWorkspace({
                        id: selected.value,
                        name: selected.label
                    });
                },
                maxDropdownHeight: 300,
                selectedOption: selectedWorkspace ? {
                    label: selectedWorkspace.name,
                    value: selectedWorkspace.id
                } : undefined,
                isLoading: isWorkspacesLoading
            })
        })
    });
};
